<template>
  <div class="form_base">
    <div class="close_button" @click="close">
      <span>ー</span>
    </div>
    <Login
      v-if="pageMode === 1"
      :isModeLP="true"
      @goToUserRegister="goToUserRegister"
    />
    <UserRegister
      v-if="pageMode === 2"
      class="register"
      :isModeLP="true"
      @confirm="pageMode = 3"
      @error="scrollTop"
    />
    <ConfirmUserRegister
      v-if="pageMode === 3"
      class="register"
      :isModeLP="true"
      @back="pageMode = 2"
      @save="userSave"
    />
  </div>
</template>

<script>
import Login from '@/components/pages/UserLogin/Login.vue';
import UserRegister from '@/components/pages/UserRegister/UserRegister.vue';
import ConfirmUserRegister from '@/components/pages/ConfirmUserRegister/ConfirmUserRegister.vue';

export default {
  components: {
    Login,
    UserRegister,
    ConfirmUserRegister,
  },

  data: () => ({
    pageMode: 1,
  }),

  watch: {
    pageMode() {
      this.scrollTop();
    },
  },

  methods: {
    close() {
      document.querySelector('html, body').style.overflow = 'auto';
      this.$emit('close');
    },
    goToUserRegister() {
      this.pageMode = 2;
    },
    scrollTop() {
      document.querySelector('.form_base').scrollTop = 0;
    },
    userSave() {
      window.location.href = '/';
    },
  },
};
</script>

<style lang="scss" scoped>
.form_base {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 80vh;
  background-color: #fff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-top: solid 1px #000;
  padding-top: 12px;
  overflow: auto;
  .close_button {
    position: absolute;
    right: 20px;
    top: 15px;
    span {
      border: solid 1px #ccc;
      border-radius: 100%;
      background-color: #fff;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 28px;
      font-weight: bold;
    }
  }
  .register {
    padding-bottom: 100px;
  }
}
</style>
